import LyTab from './src/index.vue'

LyTab.install = function (Vue) {
    Vue.component(LyTab.name, LyTab)
}

export default LyTab



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/tab/index.js
// module id = null
// module chunks = 